import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Button, Row, Col, Form, FloatingLabel, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import OuvidoriaService from '../../../services/ouvidoria';
import { Chart as ChartJS, Tooltip, Legend, CategoryScale, BarElement, LinearScale } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import Exportar from '../../../components/shared/export';

ChartJS.register(BarElement, Tooltip, Legend, CategoryScale, LinearScale);



const ListarOuvidoria = () => {
    const [ano, setAno] = useState();
    const [situacoes, setSituacoes] = useState([]);
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [
                    'red',
                    'green',
                    'blue',
                    'orange',
                    'yellow',
                    'purple',
                    'gray',
                    'maroon',
                    'fuchsia',
                    'navy'
                ],
            },
        ],
    });


    const contador = async (filtros) => {
        const situacaoCores = {
            'Resolvido': 'green',
            'Encerrado': 'green',
            'Recebido pela Prefeitura': 'blue',
            'Respondido': 'blue',
            'Pendente': 'yellow',
            'Encaminhada à Secretaria Responsável': 'orange',
            'Secretaria Responsável está atuando': 'orange',
            'Indeferido, justificado via mensagem': 'red',
            '1º Recurso': 'purple',
            '2º Recurso': 'purple',
            'Último Recurso': 'purple',
            'Encaminhado à Autoridade Superior': 'purple',
        };
        OuvidoriaService.contarSituacao(filtros)
            .then(response => {
                setSituacoes(response.data)
                const situacoes = response.data;
                const labels = situacoes.map(item => item.situacao);
                const data = situacoes.map(item => item.count);
                const backgroundColor = labels.map(situacao => situacaoCores[situacao]);

                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: "Requisições nessa situação: ",
                            data: data,
                            backgroundColor: backgroundColor,
                        },
                    ],
                });
            })
            .catch(error => {
                console.error('Não há requisições cadastradas!');
            });
    }

    useEffect(() => {
        contador(ano)
    }, []);

    const busca = async (query) => {
        if (query === "") {
            await contador();
        } else {
            var response = await contador(query);
            if (response.data.length >= 1) {
                setAno("")
            } else {
                setAno("")
            }
        }
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        return prepQuery;
    }

    return (
        <Fragment>
            <Row xs={2}>
                <Col xs={9}>
                    <Form.Group className="mb-3" controlId="Ano">
                        <FloatingLabel
                            label="Ano"
                            className="mb-3"
                        >
                            <Form.Control
                                required
                                type="number"
                                name="ano"
                                value={ano}
                                onChange={e => setAno(e.target.value)} />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs={3}>
                    <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                </Col>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                        <Accordion.Body>
                            <Row xs={1}>
                                <Col xs={12}>
                                    <Exportar data={situacoes} nome={"Situacoes"} />
                                </Col>
                            </Row>
                            <br />
                            <Row xs={1}>
                                <Col xs={12}>
                                    <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#445fc07b-ec10-48c1-8cdf-94a0ad21457c" target='_blank'>
                                        <Button>API e sua documentação</Button>
                                    </a>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Row>
            <div style={{ width: '75%', height: '750px', display: 'block', margin: '1rem auto' }}>
                <Bar data={chartData} />
            </div>
            <br />
            <br />
            <br />
            <Link to={'/ouvidoria'}>
                <Button variant="danger" type="button">
                    Voltar
                </Button>
            </Link>
        </Fragment>
    );
};

export default ListarOuvidoria;